import { Injectable } from "@angular/core";
import { GraphicsRenderRepair } from "../digital-twin/graphics/graphics-render-repair";

@Injectable({ providedIn: 'root' })
export class RepairInsertion {
    constructor(
        private graphicsRenderRepair: GraphicsRenderRepair,
    ) { }

    public insertRepair(ev) {
        this.graphicsRenderRepair.threeStartGeometryCloning();
    }
}
